module.exports = __webpack_public_path__ + "static/media/sombra-lombada-debru-interna.29f2c8aa.svg";